import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  AboutUsIcon,
  BlogIcon,
  ContactUsIcon,
  TermsIcon,
  CookiesIcon,
  PrivacyIcon,
  WebsiteIcon,
} from "../../assets/Icons";

const Footer = () => {
  return (
    <div className="footer-comp flex flex-col bg-black/90 bottom-0 left-0 right-0 w-full min-h-[100px]">
      <div className="wrapWidth wrap flex">
        <div className="flex flex-col !py-8 items-start gap-10">
          <div className="flex items-center justify-center">
            <img src="./images/logo.svg" className="" />
          </div>
          <div className="flex items-center gap-12 sm:flex-row flex-col">
            <Link
              to="/about-us"
              className="flex items-center justify-center gap-2 cursor-pointer"
            >
              <div className="flex items-center justify-center h-5 w-5">
                <AboutUsIcon />
              </div>
              <h3 className="text-white font-light text-sm">About Us</h3>
            </Link>
            <a
              href="/"
              target="_blank"
              className="flex items-center justify-center gap-2 cursor-pointer"
            >
              <div className="flex items-center justify-center h-5 w-5">
                <BlogIcon />
              </div>
              <h3 className="text-white font-light text-sm">Blog List</h3>
            </a>
            <a
              href="/"
              target="_blank"
              className="flex items-center justify-center gap-2 cursor-pointer"
            >
              <div className="flex items-center justify-center h-5 w-5">
                <ContactUsIcon />
              </div>
              <h3 className="text-white font-light text-sm">Contact Us</h3>
            </a>
          </div>
          <div className="flex w-full flex-col gap-8 items-start">
            <h1 className="text-white text-xl font-normal">
              Legal Information
            </h1>
            <div className="flex sm:items-center items-start gap-12 sm:flex-row flex-col">
              <Link
                to="/terms-conditions"
                className="flex items-center justify-center gap-2 cursor-pointer"
              >
                <div className="flex items-center justify-center h-5 w-5">
                  <TermsIcon />
                </div>
                <h3 className="text-white font-light text-sm">
                  Terms & Conditions
                </h3>
              </Link>
              <a
                href="/"
                target="_blank"
                className="flex items-center justify-center gap-2 cursor-pointer"
              >
                <div className="flex items-center justify-center h-5 w-5">
                  <CookiesIcon />
                </div>
                <h3 className="text-white font-light text-sm">
                  Cookies Policy
                </h3>
              </a>
              <Link
                to="/privacy-policy"
                className="flex items-center justify-center gap-2 cursor-pointer"
              >
                <div className="flex items-center justify-center h-5 w-5">
                  <PrivacyIcon />
                </div>
                <h3 className="text-white font-light text-sm">
                  Privacy Policy
                </h3>
              </Link>
              <a
                href="/"
                target="_blank"
                className="flex items-center justify-center gap-2 cursor-pointer"
              >
                <div className="flex items-center justify-center h-5 w-5">
                  <WebsiteIcon />
                </div>
                <h3 className="text-white font-light text-sm">
                  Website Terms of Use
                </h3>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="btm-sec flex items-center justify-center border-t border-[#BEBEBE]/20 w-full p-4">
        <p className="text-xs text-[#BEBEBE]">
          © 2024 Smarttract LLC . All Rights Reserved
        </p>
      </div>
    </div>
  );
};

export default Footer;
